import React, { useEffect, useState } from "react";
import {formatterNumberDecimals} from 'helpers/mathDictionary';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import ExpandMore from "@material-ui/icons/ExpandMore";

import styles from "assets/jss/material-dashboard-pro-react/components/accordionStyle.js";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

const sorting = (a, b) => {
  if(a.folio > b.folio) return 1;
  if(a.folio < b.folio) return -1;
  return 0;
}

export default function ControlledAccordion() {
  const useStyles = makeStyles(styles)
  const [active, setActive] = useState(-1)
  const [details, setDetails] = useState([])
  const { volumetricSelected } = useSelector(state => state.volumetricInv)

  useEffect(() => {
    if (Object.keys(volumetricSelected).length === 0) return;
    const { initial_existence, shipmentsEntry, platformDischarge, autotankDischarge, carburetorDischarge, finalExistence } = volumetricSelected
      const total20c_initial_existence= initial_existence.detail.reduce(  (acc, curr) => {return acc + curr.liters_20c }, 0)
      const total20c_shipmentsEntry= shipmentsEntry.detail.reduce(  (acc, curr) => {return acc + curr.liters_20c }, 0)
      const total20c_platformDischarge = platformDischarge.detail.reduce(  (acc, curr) => {return acc + curr.liters_20c }, 0)
      const total20c_autotankDischarge = autotankDischarge.detail.reduce(  (acc, curr) => {return acc + curr.liters_20c }, 0)
      const total20c_carburetorDischarge = carburetorDischarge.detail.reduce(  (acc, curr) => {return acc + curr.liters_20c }, 0)
      const total20c_final = total20c_initial_existence + total20c_shipmentsEntry - total20c_platformDischarge -total20c_autotankDischarge - total20c_carburetorDischarge
      const details = [
        {
          title: "Existencia Inicial",
          total: initial_existence.total,
          total20c: total20c_initial_existence,
          body: initial_existence.detail.map(detail => ({ ...detail, type: detail.tank})).sort((a, b) => {
            if(a.tank > b.tank) return 1;
            if(a.tank < b.tank) return -1;
            return 0;
          })
        },
        {
          title: "Entrada Embarques",
          total: shipmentsEntry.total,
          total20c: total20c_shipmentsEntry,
          body: shipmentsEntry.detail.map(detail => ({ ...detail, type: "Folio #"+detail.folio})).sort(sorting)
        },
        {
          title: "Salida Anden",
          total: platformDischarge.total,
          total20c: total20c_platformDischarge,
          body: platformDischarge.detail.map(detail => ({ ...detail, type: "Folio #"+detail.folio})).sort(sorting)
        },
        {
          title: "Salida Autotanque",
          total: autotankDischarge.total,
          total20c: total20c_autotankDischarge,
          body: autotankDischarge.detail.map(detail => ({ ...detail, type: "Folio #"+detail.folio})).sort(sorting)
        },
        {
          title: "Salida Carburacion",
          total: carburetorDischarge.total,
          total20c: total20c_carburetorDischarge,
          body: carburetorDischarge.detail.map(detail => ({ ...detail, type: "Folio #"+detail.folio})).sort(sorting)
        },
        {
          title: "Existencia Final",
          total: finalExistence,
          total20c: total20c_final,
          body: [
            {
              type: "Existencia Inicial",
              liters: initial_existence.total,
              liters_20c: total20c_initial_existence
            },
            {
              type: "Entrada Embarques",
              liters: shipmentsEntry.total,
              liters_20c: total20c_shipmentsEntry
            },
            {
              type: "Salida Anden",
              liters: platformDischarge.total,
              liters_20c: total20c_platformDischarge
            },
            {
              type: "Salida Autotanque",
              liters: autotankDischarge.total,
              liters_20c: total20c_autotankDischarge
            },
            {
              type: "Salida Carburación",
              liters: carburetorDischarge.total,
              liters_20c: total20c_carburetorDischarge
            }
          ]
        },
      ]
      setDetails(details)
  }, [volumetricSelected])

  const handleChange = panel => (event, expanded) => {
    setActive(expanded ? panel : -1);
  };
  const classes = useStyles();
  return (
    <div className={classes.root}>
      { details.map((detail, key) => {
        return (
          <Accordion
            expanded={active === key}
            onChange={handleChange(key)}
            key={key}
            classes={{
              root: classes.expansionPanel,
              expanded: classes.expansionPanelExpanded
            }}
            style={{
              padding: 20
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              classes={{
                root: classes.expansionPanelSummary,
                expanded: classes.expansionPanelSummaryExpaned,
                content: classes.expansionPanelSummaryContent,
                expandIcon: classes.expansionPanelSummaryExpandIcon
              }}
            >
              <Box style={{ width: '50%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap' }}>
                <Typography style={{ flexShrink: 0, fontWeight: 500 }}>{detail.title}</Typography>
                <Typography style={{ flexShrink: 0 }}>Total: {formatterNumberDecimals(detail.total,2)} Lts</Typography>
                <Typography style={{ flexShrink: 0 }}>Total 20Cº: {formatterNumberDecimals(detail.total20c,2)} Lts</Typography>
              </Box>
            </AccordionSummary>
            {
              detail.body.map((info, key) => {
                return (
                  <AccordionDetails key={key} className={classes.expansionPanelDetails}>
                    <Box style={{ width: '50%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap' }}>
                      <Typography style={{ flexShrink: 0, fontWeight: 500 }}>{info.type}: </Typography>
                      <Typography style={{ flexShrink: 0 }}>                    
                        <span style={{ 
                          color: detail.title === "Existencia Final" && info.type?.includes("Salida") 
                            ? "red" 
                            : detail.title.includes("Salida")
                              ? "red"
                              : "green"
                        }}>
                          Litros: {formatterNumberDecimals(info.liters,2)}
                        </span>
                    </Typography>
                    <Typography style={{ flexShrink: 0 }}>                    
                        <span style={{ 
                          color: detail.title === "Existencia Final" && info.type?.includes("Salida") 
                            ? "red" 
                            : detail.title.includes("Salida")
                              ? "red"
                              : "green"
                        }}>
                          Litros 20Cº: {formatterNumberDecimals(info.liters_20c,2)}
                        </span>
                    </Typography>
                    </Box>  

                  </AccordionDetails>
                )
              })
            }
          </Accordion>
        );
      })}
    </div>
  );
}
